import React from "react";
import Navbar from "../components/Navbar";
import HomePage from "../components/HomePage";
import Footer from "../components/Footer";

export default function Home() {
  

  return (
    <>
    <Navbar />
    <HomePage />
    <Footer />
    </>
  );
}
